import { RgbaColor } from "./RgbaColor";

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class WebColors {
  public static Transparent: RgbaColor = [0, 0, 0, 0];
  public static MediumVioletRed: RgbaColor = [199, 21, 133, 1];
  public static DeepPink: RgbaColor = [255, 20, 147, 1];
  public static PaleVioletRed: RgbaColor = [219, 112, 147, 1];
  public static HotPink: RgbaColor = [255, 105, 180, 1];
  public static LightPink: RgbaColor = [255, 182, 193, 1];
  public static Pink: RgbaColor = [255, 192, 203, 1];
  public static DarkRed: RgbaColor = [139, 0, 0, 1];
  public static Red: RgbaColor = [255, 0, 0, 1];
  public static Firebrick: RgbaColor = [178, 34, 34, 1];
  public static Crimson: RgbaColor = [220, 20, 60, 1];
  public static IndianRed: RgbaColor = [205, 92, 92, 1];
  public static LightCoral: RgbaColor = [240, 128, 128, 1];
  public static Salmon: RgbaColor = [250, 128, 114, 1];
  public static DarkSalmon: RgbaColor = [233, 150, 122, 1];
  public static LightSalmon: RgbaColor = [255, 160, 122, 1];
  public static OrangeRed: RgbaColor = [255, 69, 0, 1];
  public static Tomato: RgbaColor = [255, 99, 71, 1];
  public static DarkOrange: RgbaColor = [255, 140, 0, 1];
  public static Coral: RgbaColor = [255, 127, 80, 1];
  public static Orange: RgbaColor = [255, 165, 0, 1];
  public static DarkKhaki: RgbaColor = [189, 183, 107, 1];
  public static Gold: RgbaColor = [255, 215, 0, 1];
  public static Khaki: RgbaColor = [240, 230, 140, 1];
  public static PeachPuff: RgbaColor = [255, 218, 185, 1];
  public static Yellow: RgbaColor = [255, 255, 0, 1];
  public static PaleGoldenrod: RgbaColor = [238, 232, 170, 1];
  public static Moccasin: RgbaColor = [255, 228, 181, 1];
  public static PapayaWhip: RgbaColor = [255, 239, 213, 1];
  public static LightGoldenrodYellow: RgbaColor = [250, 250, 210, 1];
  public static LemonChiffon: RgbaColor = [255, 250, 205, 1];
  public static LightYellow: RgbaColor = [255, 255, 224, 1];
  public static Maroon: RgbaColor = [128, 0, 0, 1];
  public static Brown: RgbaColor = [165, 42, 42, 1];
  public static SaddleBrown: RgbaColor = [139, 69, 19, 1];
  public static Sienna: RgbaColor = [160, 82, 45, 1];
  public static Chocolate: RgbaColor = [210, 105, 30, 1];
  public static DarkGoldenrod: RgbaColor = [184, 134, 11, 1];
  public static Peru: RgbaColor = [205, 133, 63, 1];
  public static RosyBrown: RgbaColor = [188, 143, 143, 1];
  public static Goldenrod: RgbaColor = [218, 165, 32, 1];
  public static SandyBrown: RgbaColor = [244, 164, 96, 1];
  public static Tan: RgbaColor = [210, 180, 140, 1];
  public static Burlywood: RgbaColor = [222, 184, 135, 1];
  public static Wheat: RgbaColor = [245, 222, 179, 1];
  public static NavajoWhite: RgbaColor = [255, 222, 173, 1];
  public static Bisque: RgbaColor = [255, 228, 196, 1];
  public static BlanchedAlmond: RgbaColor = [255, 235, 205, 1];
  public static Cornsilk: RgbaColor = [255, 248, 220, 1];
  public static DarkGreen: RgbaColor = [0, 100, 0, 1];
  public static Green: RgbaColor = [0, 128, 0, 1];
  public static DarkOliveGreen: RgbaColor = [85, 107, 47, 1];
  public static ForestGreen: RgbaColor = [34, 139, 34, 1];
  public static SeaGreen: RgbaColor = [46, 139, 87, 1];
  public static Olive: RgbaColor = [128, 128, 0, 1];
  public static OliveDrab: RgbaColor = [107, 142, 35, 1];
  public static MediumSeaGreen: RgbaColor = [60, 179, 113, 1];
  public static LimeGreen: RgbaColor = [50, 205, 50, 1];
  public static Lime: RgbaColor = [0, 255, 0, 1];
  public static SpringGreen: RgbaColor = [0, 255, 127, 1];
  public static MediumSpringGreen: RgbaColor = [0, 250, 154, 1];
  public static DarkSeaGreen: RgbaColor = [143, 188, 143, 1];
  public static MediumAquamarine: RgbaColor = [102, 205, 170, 1];
  public static YellowGreen: RgbaColor = [154, 205, 50, 1];
  public static LawnGreen: RgbaColor = [124, 252, 0, 1];
  public static Chartreuse: RgbaColor = [127, 255, 0, 1];
  public static LightGreen: RgbaColor = [144, 238, 144, 1];
  public static GreenYellow: RgbaColor = [173, 255, 47, 1];
  public static PaleGreen: RgbaColor = [152, 251, 152, 1];
  public static Teal: RgbaColor = [0, 128, 128, 1];
  public static DarkCyan: RgbaColor = [0, 139, 139, 1];
  public static LightSeaGreen: RgbaColor = [32, 178, 170, 1];
  public static CadetBlue: RgbaColor = [95, 158, 160, 1];
  public static DarkTurquoise: RgbaColor = [0, 206, 209, 1];
  public static MediumTurquoise: RgbaColor = [72, 209, 204, 1];
  public static Turquoise: RgbaColor = [64, 224, 208, 1];
  public static Aqua: RgbaColor = [0, 255, 255, 1];
  public static Cyan: RgbaColor = [0, 255, 255, 1];
  public static Aquamarine: RgbaColor = [127, 255, 212, 1];
  public static PaleTurquoise: RgbaColor = [175, 238, 238, 1];
  public static LightCyan: RgbaColor = [224, 255, 255, 1];
  public static Navy: RgbaColor = [0, 0, 128, 1];
  public static DarkBlue: RgbaColor = [0, 0, 139, 1];
  public static MediumBlue: RgbaColor = [0, 0, 205, 1];
  public static Blue: RgbaColor = [0, 0, 255, 1];
  public static MidnightBlue: RgbaColor = [25, 25, 112, 1];
  public static RoyalBlue: RgbaColor = [65, 105, 225, 1];
  public static SteelBlue: RgbaColor = [70, 130, 180, 1];
  public static DodgerBlue: RgbaColor = [30, 144, 255, 1];
  public static DeepSkyBlue: RgbaColor = [0, 191, 255, 1];
  public static CornflowerBlue: RgbaColor = [100, 149, 237, 1];
  public static SkyBlue: RgbaColor = [135, 206, 235, 1];
  public static LightSkyBlue: RgbaColor = [135, 206, 250, 1];
  public static LightSteelBlue: RgbaColor = [176, 196, 222, 1];
  public static LightBlue: RgbaColor = [173, 216, 230, 1];
  public static PowderBlue: RgbaColor = [176, 224, 230, 1];
  public static Indigo: RgbaColor = [75, 0, 130, 1];
  public static Purple: RgbaColor = [128, 0, 128, 1];
  public static DarkMagenta: RgbaColor = [139, 0, 139, 1];
  public static DarkViolet: RgbaColor = [148, 0, 211, 1];
  public static DarkSlateBlue: RgbaColor = [72, 61, 139, 1];
  public static BlueViolet: RgbaColor = [138, 43, 226, 1];
  public static DarkOrchid: RgbaColor = [153, 50, 204, 1];
  public static Fuchsia: RgbaColor = [255, 0, 255, 1];
  public static Magenta: RgbaColor = [255, 0, 255, 1];
  public static SlateBlue: RgbaColor = [106, 90, 205, 1];
  public static MediumSlateBlue: RgbaColor = [123, 104, 238, 1];
  public static MediumOrchid: RgbaColor = [186, 85, 211, 1];
  public static MediumPurple: RgbaColor = [147, 112, 219, 1];
  public static Orchid: RgbaColor = [218, 112, 214, 1];
  public static Violet: RgbaColor = [238, 130, 238, 1];
  public static Plum: RgbaColor = [221, 160, 221, 1];
  public static Thistle: RgbaColor = [216, 191, 216, 1];
  public static Lavender: RgbaColor = [230, 230, 250, 1];
  public static MistyRose: RgbaColor = [255, 228, 225, 1];
  public static AntiqueWhite: RgbaColor = [250, 235, 215, 1];
  public static Linen: RgbaColor = [250, 240, 230, 1];
  public static Beige: RgbaColor = [245, 245, 220, 1];
  public static WhiteSmoke: RgbaColor = [245, 245, 245, 1];
  public static LavenderBlush: RgbaColor = [255, 240, 245, 1];
  public static OldLace: RgbaColor = [253, 245, 230, 1];
  public static AliceBlue: RgbaColor = [240, 248, 255, 1];
  public static Seashell: RgbaColor = [255, 245, 238, 1];
  public static GhostWhite: RgbaColor = [248, 248, 255, 1];
  public static Honeydew: RgbaColor = [240, 255, 240, 1];
  public static FloralWhite: RgbaColor = [255, 250, 240, 1];
  public static Azure: RgbaColor = [240, 255, 255, 1];
  public static MintCream: RgbaColor = [245, 255, 250, 1];
  public static Snow: RgbaColor = [255, 250, 250, 1];
  public static Ivory: RgbaColor = [255, 255, 240, 1];
  public static White: RgbaColor = [255, 255, 255, 1];
  public static Black: RgbaColor = [0, 0, 0, 1];
  public static DarkSlateGray: RgbaColor = [47, 79, 79, 1];
  public static DimGray: RgbaColor = [105, 105, 105, 1];
  public static SlateGray: RgbaColor = [112, 128, 144, 1];
  public static Gray: RgbaColor = [128, 128, 128, 1];
  public static LightSlateGray: RgbaColor = [119, 136, 153, 1];
  public static DarkGray: RgbaColor = [169, 169, 169, 1];
  public static Silver: RgbaColor = [192, 192, 192, 1];
  public static LightGray: RgbaColor = [211, 211, 211, 1];
  public static Gainsboro: RgbaColor = [220, 220, 220, 1];
  public static RebeccaPurple: RgbaColor = [102, 51, 153, 1];
}
